import React from 'react';
import PublishedTime from '../../_partials/PublishedTime';
import UserAvatar from '../../../User/Avatar/UserAvatar';
import UserLink from '../../../User/Link/UserLink';
import s from './UserInfoBlock.scss';
var UserInfoBlock = function (_a) {
    var user = _a.user, publishedTime = _a.publishedTime, moneyPromo = _a.moneyPromo;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(UserAvatar, { size: 32, user: user, className: s['author-avatar'] }),
        React.createElement("span", { className: s['author-username'] },
            React.createElement(UserLink, { user: user, className: s['author-userlink'] }),
            publishedTime && (React.createElement(PublishedTime, { publishedTime: publishedTime, withoutText: true })))));
};
UserInfoBlock.displayName = 'UserInfoBlock';
export default UserInfoBlock;
//# sourceMappingURL=UserInfoBlock.js.map